import React from "react"

import {
  HeroSection,
  AboutSection,
  ServicesSection,
  FeaturedServicesSection,
  ContactSection,
  CTASection,
  PackagesSection,
  EventsSection,
  CredentialsSection,
  CTABannerSection,
  KeywordsSection,
  HeaderSection,
  FooterSection,
  FAQSection,
  ReviewsSection,
  GallerySection,
  QuoteSection,
  SubHeroSection,
  GenericSection
} from "./components"

const SectionRenderer = ({
  section,
  practice,
  theme,
  highlightedField,
  pageSlug = null,
  defaultPageType = null,
  viewMode = "",
  deviceType = "desktop",
  isCustom = false // eslint-disable-line no-unused-vars
}) => {
  const commonProps = { section, practice, theme, highlightedField, viewMode, deviceType }

  // Create anchor ID for the section - include type, layout variant (if available), and id for better identification
  const layoutVariant = section.settings?.layout
  const sectionAnchorId =
    section.layout === "events"
      ? "events-section-full"
      : layoutVariant
      ? `section-${section.layout}-${layoutVariant}-${section.id}`
      : `section-${section.layout}-${section.id}`

  // Wrap the section with an anchor element for scrolling
  const renderSectionWithAnchor = (sectionComponent) => (
    <div id={sectionAnchorId} className="scroll-mt-20">
      {sectionComponent}
    </div>
  )

  switch (section.layout) {
    case "hero": {
      // Use HeroSection for home page (by defaultPageType) and custom pages, SubHeroSection for other pages
      const shouldUseHeroSection = defaultPageType === "home"
      return renderSectionWithAnchor(
        shouldUseHeroSection ? <HeroSection {...commonProps} /> : <SubHeroSection {...commonProps} />
      )
    }

    case "sub_hero":
      // Use HeroSection for custom pages with sub_hero layout, SubHeroSection for others
      // return renderSectionWithAnchor(isCustom ? <HeroSection {...commonProps} /> : <SubHeroSection {...commonProps} />)
      return renderSectionWithAnchor(<SubHeroSection {...commonProps} />)

    case "about":
      return renderSectionWithAnchor(<AboutSection {...commonProps} />)

    case "services":
      return renderSectionWithAnchor(
        <ServicesSection {...commonProps} pageSlug={pageSlug} defaultPageType={defaultPageType} />
      )

    case "featured_services":
      return renderSectionWithAnchor(
        <FeaturedServicesSection {...commonProps} pageSlug={pageSlug} defaultPageType={defaultPageType} />
      )

    case "contact":
      return renderSectionWithAnchor(<ContactSection {...commonProps} />)

    case "cta_content":
      return renderSectionWithAnchor(<CTASection {...commonProps} />)

    case "packages":
      return renderSectionWithAnchor(
        <PackagesSection {...commonProps} pageSlug={pageSlug} defaultPageType={defaultPageType} />
      )

    case "events":
      return renderSectionWithAnchor(
        <EventsSection {...commonProps} pageSlug={pageSlug} defaultPageType={defaultPageType} />
      )

    case "credentials":
      return renderSectionWithAnchor(<CredentialsSection {...commonProps} />)

    case "cta_banner":
      return renderSectionWithAnchor(<CTABannerSection {...commonProps} />)

    case "keywords":
      return renderSectionWithAnchor(<KeywordsSection {...commonProps} />)

    case "header":
      return renderSectionWithAnchor(<HeaderSection {...commonProps} />)

    case "footer":
      return renderSectionWithAnchor(<FooterSection {...commonProps} />)

    case "faq":
      return renderSectionWithAnchor(<FAQSection {...commonProps} />)

    case "quote":
      return renderSectionWithAnchor(<QuoteSection {...commonProps} />)

    case "reviews":
      return renderSectionWithAnchor(
        <ReviewsSection {...commonProps} pageSlug={pageSlug} defaultPageType={defaultPageType} />
      )

    case "gallery":
      return renderSectionWithAnchor(<GallerySection {...commonProps} />)

    // Sections that still use the generic renderer
    default:
      return renderSectionWithAnchor(<GenericSection {...commonProps} />)
  }
}

export default SectionRenderer
